import api from "./api";
import auth from "./auth";

export default {
	fetchDataStudioLink(uuid) {
		return new Promise((resolve, reject) => {
			api.post("merchant-service/cms/data-studio/" + uuid, {}, auth.getHeader())
				.then(response => {
					return resolve(response);
				})
				.catch((status, errors) => {
					reject(errors);
				});
		});
	}
};
